module.exports = __webpack_public_path__ + "img/switzerland.1d69991a.svg";